import { VehicleTypePost, VehicleTypePut, VehicleTypeSearch } from '../interfaces/VehicleType';
import { getUrlMvmApi } from '../utils/util';
import ApiHandler from './ApiHandler';

export const baseURL = String(getUrlMvmApi(window));

export default class VehicleTypeApi {
    static async searchVehicleType(params: VehicleTypeSearch) {
        var response = await ApiHandler(baseURL).get('VehicleTypes/search', { params });
        return response.data;
    }

    static async getVehicleType(code: string) {
        var response = await ApiHandler(baseURL).get(`VehicleTypes/?code=${code}`);
        return response.data;
    }

    static async postVehicleType(post: VehicleTypePost) {
        var response = await ApiHandler(baseURL).post('VehicleTypes', post);
        return response.data;
    }

    static async putVehicleType(put: VehicleTypePut) {
        var response = await ApiHandler(baseURL).put('VehicleTypes', put);
        return response.data;
    }

    static async deleteVehicleType(code: string) {
        var response = await ApiHandler(baseURL).delete(`VehicleTypes/?code=${code}`);
        return response.data;
    }

    static async searchAll() {
        var response = await ApiHandler(baseURL).get('VehicleTypes/lookup');
        return response.data;
    }

    static async deleteVehicleTypeCache() {
        var response = await ApiHandler(baseURL).delete('VehicleTypes/cache');
        return response.data;
    }
}
